import React, { ReactNode, useState } from "react";
import { cn } from "../../utils/utils";
import { useSelector } from "react-redux";
import { UserSliceType } from "../../lib/redux/slices/userSlice";
import ImageIcon from "./ImageIcon";
import { ClassValue } from 'clsx';

type PropsType = {
  inputProps: React.HTMLProps<HTMLInputElement>;
  label?: string;
  labelStyle?: ClassValue;
  icon?: string | any;
  Tooltip?: any;
  toggleIcon?: string | any;
  iconWidth?: number;
  iconHeight?: number;
  title?: string;
  customClass?: ClassValue;
  isRequired?: boolean;
  iconCustomStyle?: string;
};

const Input:React.FC<PropsType & React.ComponentPropsWithoutRef<"input">> = ({
  inputProps,
  label,
  icon,
  toggleIcon,
  title,
  customClass,
  iconHeight,
  iconWidth,
  Tooltip,
  labelStyle,
  isRequired = true,
  iconCustomStyle=""
  // ...otherProps
}: PropsType) => {
  const [showPassword, setShowPassword] = useState(false);

  const lang = useSelector((state: any) => state.user.lang);

  const handleToggle = () => {
    setShowPassword(!showPassword);
  };
  return (
    <div className="w-full relative flex flex-col ">
      {label && (
        <label
          className={cn(
            `flex mb-2 text-sm  text-primary dark:text-white text-start gap-1`,
            labelStyle
          )}
        >
          {label}
          {isRequired && <span className="text-red-500 pr-2"> *</span>}
          {Tooltip && Tooltip()}
        </label>
      )}
      <div className="relative w-full h-full">
        <input
          {...inputProps}
          
          type={showPassword ? "text" : inputProps.type}
          className={cn(
            "bg-white dark:bg-primaryLight dark:text-white border h-full  text-sm   border-gray-300 text-[#747474] rounded-lg   block w-full p-3 placeholder-gray-400 ",
            customClass
          )}
        />

        <div
          className={cn(`absolute top-2.5 ${
            lang == "ar" ? "left-2" : "right-2"
          }  text-primary dark:text-white text-xs cursor-pointer `, iconCustomStyle)}
          onClick={toggleIcon ? handleToggle : () => {}}
        >
          {icon && (
            <ImageIcon
              Icon={showPassword ? toggleIcon : icon}
              //alt="icon"
              width={iconWidth || 28}
              height={iconHeight || 28}
            />
          )}
          {title && <p className="text-sm mt-1">{title}</p>}
        </div>
      </div>
    </div>
  );
};

export default Input;
